/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Catalog_Pdf_HintInputs */

const cs_workflow_catalog_pdf_hint = /** @type {(inputs: Workflow_Catalog_Pdf_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygeneruje katalogový PDF pro nemovitost z payloadu.`)
};

const en_workflow_catalog_pdf_hint = /** @type {(inputs: Workflow_Catalog_Pdf_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generates a property catalog PDF for the payload property.`)
};

/**
* | output |
* | --- |
* | "Generates a property catalog PDF for the payload property." |
*
* @param {Workflow_Catalog_Pdf_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_catalog_pdf_hint = /** @type {((inputs?: Workflow_Catalog_Pdf_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Catalog_Pdf_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_catalog_pdf_hint(inputs)
	return cs_workflow_catalog_pdf_hint(inputs)
});